import { ScrollView, VStack } from 'native-base';
import { useTranslation } from 'react-i18next';

import { useSalesLaborTracker } from '../context/sales-labor-tracker.context';
import { SalesChart } from './sales-chart';
import { SalesTable } from './sales-table';
import { LaborTable } from './labor-table';
import { DaypartListView } from './daypart-list-view';

type SalesTrackerProps = {
  isDetailed?: boolean;
};

export const SalesTracker = ({ isDetailed }: SalesTrackerProps) => {
  const { t } = useTranslation();
  const partNumber = useSalesLaborTracker(_ => _.partNumber);
  const hasLaborTracker = useSalesLaborTracker(_ => _.hasLaborTracker);

  const sales = useSalesLaborTracker(_ => _.sales);
  const daypart = sales.dayparts.find(_ => _.partNumber === partNumber) ?? sales.total;

  return (
    <VStack flex={1}>
      {/* Dayparts */}
      <DaypartListView />
      {/* Content */}
      <VStack flex={1} bg="grayCool.100">
        <ScrollView flex={1} showsVerticalScrollIndicator={false}>
          <VStack space={2} pt={1} px={3} pb={4}>
            <SalesChart daypart={daypart} />

            <SalesTable daypart={daypart} isDetailed={isDetailed} />

            {hasLaborTracker && <LaborTable daypart={daypart} isDetailed={isDetailed} />}
          </VStack>
        </ScrollView>
      </VStack>
    </VStack>
  );
};
